import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { ChartStyle } from '../shared/components/chart';
import { LoadingScreen, ScrollToTop, NotistackProvider, ProgressBarStyle, Toast } from '../shared/components/base';
import MotionLazyContainer from '../shared/components/animate/MotionLazyContainer';
import ThemeProvider from '../theme';
import Router from '../shared/routes';
import { routeKeys } from '../utils/constants';
import ThemeSettings from '../shared/components/settings';

const AppRouter = () => {
  const { pathname } = useLocation();

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <Suspense fallback={<LoadingScreen isDashboard={pathname.includes(routeKeys.home)} />}>
            <NotistackProvider>
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              <Router />
              <Toast />
            </NotistackProvider>
          </Suspense>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
};

export default AppRouter;
